/** Sentinel: show generic i18n error in detail modal instead of raw API string. */
export const GENERIC_DETAIL_ERROR = 'GENERIC';
export const RATE_LIMITED_DETAIL_ERROR = 'RATE_LIMITED';
